export const sendEmailComission = async ({ recipientEmail, orderNumber, comisionAmount }) => {
    try {
        const emailBody = `
            <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 20px;">
                <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                    <div style="text-align: center; padding: 20px; background-color: #d0c0e1; color: #ffffff; margin-top: 20px">
                        <img src="https://cdn.shopify.com/s/files/1/0835/6577/3146/files/bymo-athletes-program-logo.png?v=1737565562" alt="BYMO Logo" style="max-width: 150px; margin-bottom: 10px;">
                    </div>
                    <div style="padding: 20px; text-align: center;">
                        <p style="font-size: 16px; color: #333333; margin: 0;">
                            <strong>Felicitări!</strong> Ai generat o comandă care îți aduce un comision de 
                            <strong style="color: #4caf50;">${comisionAmount} lei</strong>.
                        </p>
                        <p style="font-size: 14px; color: #555555; margin: 20px 0;">
                            Poți accesa platforma bymo.live pentru a vedea mai multe detalii și pentru a monitoriza performanța ta.
                        </p>
                        <a href="https://bymo.live" target="_blank" style="text-decoration: none;">
                            <button style="background-color: #543e79; color: #ffffff; padding: 10px 20px; border: none; border-radius: 30px; cursor: pointer; font-size: 16px;">
                                Accesează Platforma bymo.live
                            </button>
                        </a>
                    </div>
                    <div style="padding: 10px; text-align: center; background-color: #f1f1f1; color: #888888; font-size: 12px;">
                        <p style="margin: 0;">© ${new Date().getFullYear()} BYMO. Toate drepturile rezervate.</p>
                    </div>
                </div>
            </div>
        `;

        const response = await fetch(
            "https://bymolive-backend-995926394015.us-central1.run.app/api/email-new-order-notification",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    recipient_email: recipientEmail,
                    comision_amount: comisionAmount,
                    subject: "BYMO Athletes - Comision generat",
                    body: emailBody,
                    order_number: orderNumber,
                }),
            }
        );

        if (!response.ok) {
            throw new Error("Failed to send email notification.");
        }

        const data = await response.json();
        console.log("Email notification sent successfully:", data.message);
        return data.message;
    } catch (error) {
        console.error("Error sending email notification:", error.message);
        throw error;
    }
};
